import { ApiStatus } from "../types/api/status"
import { useDispatch, useSelector } from "../redux/store"
import { CustomSnackbar } from "../components/common/CustomSnackbar/CustomSnackbar"
import { readLocalStorage } from "../toolbox/helpers/local-storage-helpers"
import { LocalStorageKey } from "../types"
import { changeStatus, onSetSelectedUnitMeasure, selectUnitMeasureState, setAction } from "../redux/slices/unitMeasureSlice"
import { UnitMeasureAPI } from "../apis/UnitMeasureAPI"
import { unitMeasure } from "../types/slices/unitMeasureType"

export const useUnitMeasureStore = () => {

    const dispatch = useDispatch()
    const { unitMeasure, unitMeasureSelected, status, action } = useSelector(selectUnitMeasureState)

    const userData = readLocalStorage(LocalStorageKey.USER_DATA)
    const idcompany = userData?.idcompany

    const getUnitMeasure = async (search='') => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UnitMeasureAPI.getUnitMeasure({search:search})
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false; 
            }
            const { detail } = response.data
            dispatch(changeStatus(ApiStatus.FETCHED))
            return detail;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const createUnitMeasure = async (data: any) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UnitMeasureAPI.createUnitMeasure(data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const editUnitMeasure = async (idstore: number, data: any) => {
        try {
        dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UnitMeasureAPI.editUnitMeasure(idstore, data)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const deleteUnitMeasure = async (idstore: number) => {
        try {
            dispatch(changeStatus(ApiStatus.FETCHING))
            const response = await UnitMeasureAPI.deleteUnitMeasure(idstore)
            if (!response?.status) {
                dispatch(changeStatus(ApiStatus.FETCHED))
                CustomSnackbar('error', response.data.message || "");
                return false;
            }
            dispatch(changeStatus(ApiStatus.FETCHED))
            CustomSnackbar('success', response.data.message  || "");
            return true;
        } catch (error) {
            console.log(error)
            return dispatch(changeStatus(ApiStatus.FETCHED))
        }
    }

    const setSelectedUnitMeasure = (store: unitMeasure) => {
        try {
            dispatch(onSetSelectedUnitMeasure(store))
        } catch (error) {
            console.log(error)
        }
    }

    const setActionUnitMeasure = (state) => {
        try {
            dispatch(setAction(state))
        } catch (error) {
            console.log(error)
        }
    }

    return {
        //states
        unitMeasure,
        unitMeasureSelected,
        status,
        action,
        //actions
        getUnitMeasure,
        createUnitMeasure,
        editUnitMeasure,
        deleteUnitMeasure,
        setSelectedUnitMeasure,
        setActionUnitMeasure,
    }
}